import React, { FC } from "react";
import { Box, Checkbox as CheckboxThemeUI, Label, Link } from "theme-ui";

interface CheckboxDefaultProps {
  label: string;
  linkLabel: string;
  linkUrl: string;
  checked: boolean;
  onChange: (isChecked: boolean) => void;
  // eslint-disable-next-line react/require-default-props
}
export const Checkbox: FC<CheckboxDefaultProps> = ({
  label,
  linkLabel,
  linkUrl,
  checked,
  onChange,
}: CheckboxDefaultProps) => (
  <Box sx={{ gridColumn: "1 / span 2" }}>
    <Label
      sx={{
        alignItems: "center",
        marginBottom: 0,
        paddingLeft: "1.25rem",
        display: "flex",
      }}
    >
      <CheckboxThemeUI
        sx={{
          width: "1.125rem",
          height: "1.125rem",
          minHeight: "1.125rem",
          minWidth: "1.125rem",
          cursor: "pointer",
          borderRadius: "0",
          marginTop: 0,
          marginLeft: "-1.125rem",
          marginRight: ".5rem",
        }}
        checked={checked}
        onChange={(e): void => onChange(e.target.checked)}
      />
      <span>
        {label}{" "}
        <Link href={linkUrl} target="_blank">
          {linkLabel}
        </Link>
      </span>
    </Label>
  </Box>
);
